export default {
  nickname: state => state.user.nickname,
  role: state => state.user.role,
  profile: state => state.user.profile,
  routes: state => state.permission.routes
}
